<template>
  <el-form
    id="job-form"
    :model="ruleForm"
    ref="form"
    label-width="95px"
    size="small"
  >
    <el-form-item label="选择JOB">
      <el-select v-model="nodeName" class="node-name" @change="nodeSelect">
        <el-option
          v-for="(item, index) in node"
          :key="index"
          :label="item.jobName"
          :value="item.nodeId"
        ></el-option>
      </el-select>
    </el-form-item>
    <!-- <el-form-item label="Job名称">
      <el-input :disabled="disabled" :maxlength="20" :minlength="1" v-model="ruleForm.jobName" @change="jobNameChange"></el-input>
    </el-form-item> -->
    <el-form-item label="插件名称">
      <el-input v-model="ruleForm.name" disabled></el-input>
    </el-form-item>
    <el-form-item label="插件版本">
      <el-select
        :disabled="disabled"
        class="node-ver"
        v-model="ruleForm.version"
        @change="versionChange"
      >
        <el-option
          v-for="(item, index) in verOptions"
          :key="index"
          :label="item"
          :value="item"
        ></el-option>
      </el-select>
    </el-form-item>
    <template v-for="(job, k) in ruleForm.jobParams">
      <el-form-item
        v-if="job.userSetAble"
        :key="k"
        :label="job.name"
        :required="job.required"
        label-width="45%"
      >
        <el-popover
          placement="top-end"
          width="350"
          trigger="hover"
          :open-delay="2000"
          :content="job.description"
        >
          <el-input
            slot="reference"
            :disabled="disabled"
            v-model="job.defaultValue"
          ></el-input>
        </el-popover>
      </el-form-item>
    </template>
  </el-form>
</template>

<script>
export default {
  name: "job-form",
  props: {
    node: {
      type: Array
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      nodeName: "",
      ruleForm: {
        jobName: "",
        name: "",
        version: "",
        jobParams: {}
      },
      verOptions: []
    };
  },
  watch: {
    node(v) {
      if (v.length) {
        this.nodeName = v[v.length - 1].nodeId;
        this.nodeSelect(this.nodeName);
        // let hasNode = v.some(node => node.nodeId === this.ruleForm.nodeId);
        // if (!hasNode) {
        //   this.nodeName = v[v.length - 1].nodeId;
        //   this.nodeSelect(this.nodeName);
        // }
      } else {
        this.nodeName = "";
        this.ruleForm = {
          jobName: "",
          name: "",
          version: "",
          jobParams: {}
        };
      }
    }
  },
  methods: {
    versionChange(v) {
      this.$http
        .get(
          `/gavial/v1/plugin/view/detail?name=${this.ruleForm.name}&version=${v}`
        )
        .then(res => {
          let data = res.data.data.params.paramSchemas;
          if (this.ruleForm.jobParams.length) {
            this.ruleForm.jobParams.forEach(item => {
              if (item.userSetAble) {
                let index = data.findIndex(item2 => item.name === item2.name);
                if (index > -1) {
                  data[index].defaultValue = item.defaultValue;
                }
              }
            });
          }
          this.ruleForm.pkgId = res.data.data.pkgId;
          this.$set(this.ruleForm, "jobParams", data);
        });
    },
    nodeSelect(v) {
      this.ruleForm = this.node.find(node => node.nodeId === v);
      this.$http
        .get(`/gavial/v1/plugin/view/versions?pkgName=${this.ruleForm.name}`)
        .then(res => {
          this.verOptions = res.data.data;
        });
    },
    // job名称修改 取消
    // jobNameChange() {
    //   this.$parent.$parent.$parent.$parent.$refs.drage.setNode(
    //     this.node.find(node => node.nodeId === this.nodeName)
    //   );
    // },
    validate() {
      if (this.node.length) {
        return new Promise((resolve, reject) => {
          this.node.forEach(node => {
            if (
              node.jobParams.some(
                job => job.userSetAble && job.required && !job.defaultValue
              )
            ) {
              this.nodeName = node.nodeId;
              this.nodeSelect(node.nodeId);
              this.$message({
                type: "error",
                message: `${node.jobName} 参数填写不完整`
              });
              reject("second");
            }
          });
          resolve(this.node);
        });
      } else {
        this.$message.error({
          message: `请创建至少一个job`
        });
        return new Promise((resolve, reject) => {
          reject("");
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#job-form {
  padding: 15px 10px;
  .node-name,
  .node-ver {
    width: 100%;
  }
}
</style>
